import { render } from "./df-ui2-banner.vue?vue&type=template&id=3a1a1f4e&scoped=true"
import script from "./df-ui2-banner.vue?vue&type=script&lang=js"
export * from "./df-ui2-banner.vue?vue&type=script&lang=js"

import "./df-ui2-banner.vue?vue&type=style&index=0&id=3a1a1f4e&scoped=true&lang=scss"

import exportComponent from "D:\\phpEnv\\www\\zy\\frontend\\zhiyadu\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a1a1f4e"]])

export default __exports__